import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const API_URL = `${API_BASE_URL}/actas`;

// Función para obtener el acta
export const getActaByTemporadaAndCodActa = async (
  idTemporada,
  codActa,
  navigate
) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}/${idTemporada}/${codActa}`,
      {
        method: "GET",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener el acta");
  } catch (error) {
    throw error;
  }
};
